<template>
    <div id="noc-hcpcs-code-list">
        <div class="row topactionform">
            <div class="col-xs-5" style="padding-right: 0">
                <div class="smalltitle">NOC HCPCS Code</div>
            </div>
            <div class="col-xs-5">
                <form class="onelineform flowsearch" @submit.prevent="filterNocCode">
                    <button type="submit" class="submit btn light" style="float: right; width: 10%">
                        <i class="fa fa-search"></i>
                    </button>
                    <input type="text" placeholder="Code, description or leave blank for search all"
                           v-model="formSearch.keySearch"
                           class="keyinput" style="width: 60%; border-left: 1px solid #e1e1e1; float: right">
                </form>
            </div>
            <div class="col-xs-2">
                <button class="btn light btn-block" @click.prevent="showModalCreateNew">Create New</button>
            </div>
        </div>
        <div class="blockcont">
            <ul class="itemlisttable ptemr-list noc-code-list">
                <li class="itemlisthead">
                    <div class="item-code">HCPCS Code</div>
                    <div class="item-description">Description</div>
                    <div class="item-action">Action</div>
                </li>
                <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt">
                    <i class="fas fa-spinner fa-spin"></i>
                </li>
                <li v-if="!isLoading && dataNocCodes.length === 0" style="text-align: center; font-size: 16pt">
                    No records found
                </li>
                <li v-if="!isLoading" class="item-service" v-for="item in dataNocCodes" :key="item._id">
                    <div class="item-code">{{item.CODE_HCPCS}}</div>
                    <div class="item-description">{{item.Description}}</div>
                    <div class="item-action itemaction">
                        <dropdown>
                            <a href="javascript:void(0)" title="Choose action" data-toggle="dropdown">
                                <i class="fa fa-cog"></i>
                            </a>
                            <template slot="dropdown">
                                <div>
                                    <a href="javascript:void(0)" title="Edit"
                                       @click.prevent="editNocCode(item)">Edit</a>
                                    <a href="javascript:void(0)" title="Delete"
                                       @click.prevent="deleteNocCode(item)">Delete</a>
                                </div>
                            </template>
                        </dropdown>
                    </div>
                </li>
            </ul>
        </div>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>
        <modal-new-noc-hcpcs-code
                v-if="dataCreate.modal"
                :nocCodeEdit="dataCreate.nocCode"
                @updateModal="dataCreate.modal = $event"
                @createNew="eventCreateNewNocCode"
        ></modal-new-noc-hcpcs-code>
    </div>
</template>

<script>
import Pagination from '../../global/Pagination.vue'
import httpClient from '../../client'
import CommonMixin from '../../mixins/general/CommonMixin.vue'
import TimeMixin from '../../mixins/general/TimeMixin.vue'

const ModalNewNocHcpcsCode = () => import('./part-emr-data/ModalNewNocHcpcsCode')

export default {
  name: 'NocHcpcsCode',
  components: {
    Pagination,
    ModalNewNocHcpcsCode
  },
  mixins: [CommonMixin, TimeMixin],
  data () {
    return {
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoading: false,
      formSearch: {
        keySearch: ''
      },
      dataNocCodes: [],
      dataCreate: {
        modal: false,
        nocCode: null
      }
    }
  },
  mounted () {
    this.loadListNocCode()
  },
  methods: {
    deleteNocCode (item) {
      this.$confirm({
        title: 'Confirm',
        content: `Are you sure to delete this NOC code?`
      }).then(async () => {
        try {
          const response = await httpClient.delete(`/emr-data/noc-hcpcs-code/${item._id}`)
          if (response.data.s === 200) {
            this.alertSuccess(response.data.msg)
            this.loadListNocCode()
          } else {
            this.alertError(response.data.msg)
          }
        } catch (e) {
          this.alertError('Server error.Try again later')
        }
      })
    },
    editNocCode (item) {
      this.dataCreate.nocCode = item
      this.dataCreate.modal = true
    },
    eventCreateNewNocCode () {
      this.loadListNocCode()
    },
    showModalCreateNew () {
      this.dataCreate.modal = true
      this.dataCreate.nocCode = null
    },
    filterNocCode () {
      this.paginate.page = 1
      this.loadListNocCode()
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadListNocCode()
    },
    async loadListNocCode () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      const params = {
        page: this.paginate.page,
        perPage: this.paginate.perPage,
        keySearch: this.formSearch.keySearch
      }
      try {
        const response = await httpClient.get(`/emr-data/noc-hcpcs-code`, { params: params })
        this.isLoading = false
        if (response.data.s === 200) {
          const nocCodes = response.data.data.nocCodes.data ? response.data.data.nocCodes.data : []
          this.dataNocCodes = nocCodes
          this.paginate.page = Number(response.data.data.nocCodes.currentPage)
          this.paginate.total = response.data.data.nocCodes.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError('Server error when load NOC codes. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
        this.alertError('Server error when load NOC codes. F5 and refresh browser')
      }
    }
  }
}
</script>

<style scoped="">
    .onelineform {
        border-left: none !important;
    }

    .item-code {
        width: 20% !important;
        float: left !important;
        min-height: 1px !important;
        cursor: pointer;
        font-weight: bold;
    }

    .item-description {
        width: 70% !important;
        float: left !important;
        min-height: 1px !important;
        cursor: pointer;
        padding-right: 15px;
    }

    .item-action {
        width: 5% !important;
        float: right !important;
        text-align: right;
        padding-right: 15px;
    }
</style>
